import { atom } from 'recoil'

export const isOpenUserMenuState = atom({
  key: 'isOpenUserMenuState',
  default: false
})
